// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeedbackModal_modalOverlay__vlbSB {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: FeedbackModal_fadeIn__jkezu 0.2s ease-out;
}

.FeedbackModal_modalContainer__4p05D {
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  margin: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: FeedbackModal_slideIn__SiIDn 0.3s ease-out;
}

.FeedbackModal_modalHeader__zUeQl {
  padding: 20px 24px;
  background: #1565c0;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.FeedbackModal_modalHeader__zUeQl h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.FeedbackModal_closeButton__CdGZm {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.FeedbackModal_closeButton__CdGZm:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.FeedbackModal_modalContent__fSl9Z {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.FeedbackModal_questionInfo__UHkwr h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.FeedbackModal_questionText__w0p5c {
  margin: 0;
  padding: 16px;
  background: #f8f9fa;
  border-left: 4px solid #1565c0;
  border-radius: 8px;
  color: #555;
  line-height: 1.5;
  font-size: 14px;
}

.FeedbackModal_feedbackSection__4GBji label {
  display: block;
}
.FeedbackModal_feedbackSection__4GBji label h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.FeedbackModal_feedbackTextarea__qVzlO {
  width: 100%;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
  resize: vertical;
  min-height: 120px;
  transition: border-color 0.2s;
}
.FeedbackModal_feedbackTextarea__qVzlO:focus {
  outline: none;
  border-color: #1565c0;
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.1);
}
.FeedbackModal_feedbackTextarea__qVzlO::placeholder {
  color: #999;
}
.FeedbackModal_feedbackTextarea__qVzlO:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.FeedbackModal_processInfo__P07nJ {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.FeedbackModal_processTag__SkAfU,
.FeedbackModal_questionTag__eoR5z {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.FeedbackModal_processTag__SkAfU {
  background: #e3f2fd;
  color: #1565c0;
}

.FeedbackModal_questionTag__eoR5z {
  background: #f3e5f5;
  color: #7b1fa2;
}

.FeedbackModal_modalFooter__2l2KQ {
  padding: 20px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.FeedbackModal_cancelButton__ggoIh,
.FeedbackModal_submitButton__JN8ad {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}
.FeedbackModal_cancelButton__ggoIh:disabled,
.FeedbackModal_submitButton__JN8ad:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.FeedbackModal_cancelButton__ggoIh {
  background: #f5f5f5;
  color: #666;
}
.FeedbackModal_cancelButton__ggoIh:hover:not(:disabled) {
  background: #e0e0e0;
}

.FeedbackModal_submitButton__JN8ad {
  background: #1565c0;
  color: white;
}
.FeedbackModal_submitButton__JN8ad:hover:not(:disabled) {
  background: #0d47a1;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.3);
}
.FeedbackModal_submitButton__JN8ad:disabled {
  background: #ccc;
}

@keyframes FeedbackModal_fadeIn__jkezu {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes FeedbackModal_slideIn__SiIDn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .FeedbackModal_modalContainer__4p05D {
    margin: 0;
    max-height: 100vh;
    border-radius: 0;
  }
  .FeedbackModal_modalContent__fSl9Z {
    padding: 20px;
  }
  .FeedbackModal_modalFooter__2l2KQ {
    padding: 16px 20px;
    flex-direction: column;
  }
  .FeedbackModal_modalFooter__2l2KQ .FeedbackModal_cancelButton__ggoIh,
  .FeedbackModal_modalFooter__2l2KQ .FeedbackModal_submitButton__JN8ad {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FeedbackModal/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oDAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iCAAA;AAAF;AAEE;EACE,0CAAA;AAAJ;;AAIA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAKE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAHF;;AAOE;EACE,cAAA;AAJJ;AAMI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAJN;;AASA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AANF;AAQE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AANJ;AASE;EACE,WAAA;AAPJ;AAUE;EACE,yBAAA;EACA,mBAAA;AARJ;;AAYA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AATF;;AAYA;;EAEE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;AATF;;AAYA;EACE,mBAAA;EACA,cAAA;AATF;;AAYA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AATF;;AAYA;;EAEE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AATF;AAWE;;EACE,mBAAA;EACA,YAAA;AARJ;;AAYA;EACE,mBAAA;EACA,WAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,mBAAA;EACA,YAAA;AAVF;AAYE;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;AAVJ;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE;IACE,UAAA;EAZF;EAcA;IACE,UAAA;EAZF;AACF;AAeA;EACE;IACE,UAAA;IACA,wCAAA;EAbF;EAeA;IACE,UAAA;IACA,iCAAA;EAbF;AACF;AAgBA;EACE;IACE,SAAA;IACA,iBAAA;IACA,gBAAA;EAdF;EAiBA;IACE,aAAA;EAfF;EAkBA;IACE,kBAAA;IACA,sBAAA;EAhBF;EAkBE;;IAEE,WAAA;EAhBJ;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.modalContainer {\n  width: 100%;\n  max-width: 600px;\n  max-height: 80vh;\n  margin: 20px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideIn 0.3s ease-out;\n}\n\n.modalHeader {\n  padding: 20px 24px;\n  background: #1565c0;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n}\n\n.modalContent {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.questionInfo {\n  h4 {\n    margin: 0 0 8px 0;\n    color: #333;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n\n.questionText {\n  margin: 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-left: 4px solid #1565c0;\n  border-radius: 8px;\n  color: #555;\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n.feedbackSection {\n  label {\n    display: block;\n    \n    h4 {\n      margin: 0 0 12px 0;\n      color: #333;\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n}\n\n.feedbackTextarea {\n  width: 100%;\n  padding: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  line-height: 1.5;\n  resize: vertical;\n  min-height: 120px;\n  transition: border-color 0.2s;\n  \n  &:focus {\n    outline: none;\n    border-color: #1565c0;\n    box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.1);\n  }\n  \n  &::placeholder {\n    color: #999;\n  }\n  \n  &:disabled {\n    background-color: #f5f5f5;\n    cursor: not-allowed;\n  }\n}\n\n.processInfo {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.processTag,\n.questionTag {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.processTag {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.questionTag {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.modalFooter {\n  padding: 20px 24px;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.cancelButton,\n.submitButton {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 100px;\n  \n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.cancelButton {\n  background: #f5f5f5;\n  color: #666;\n  \n  &:hover:not(:disabled) {\n    background: #e0e0e0;\n  }\n}\n\n.submitButton {\n  background: #1565c0;\n  color: white;\n  \n  &:hover:not(:disabled) {\n    background: #0d47a1;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.3);\n  }\n  \n  &:disabled {\n    background: #ccc;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 768px) {\n  .modalContainer {\n    margin: 0;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .modalContent {\n    padding: 20px;\n  }\n  \n  .modalFooter {\n    padding: 16px 20px;\n    flex-direction: column;\n    \n    .cancelButton,\n    .submitButton {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `FeedbackModal_modalOverlay__vlbSB`,
	"fadeIn": `FeedbackModal_fadeIn__jkezu`,
	"modalContainer": `FeedbackModal_modalContainer__4p05D`,
	"slideIn": `FeedbackModal_slideIn__SiIDn`,
	"modalHeader": `FeedbackModal_modalHeader__zUeQl`,
	"closeButton": `FeedbackModal_closeButton__CdGZm`,
	"modalContent": `FeedbackModal_modalContent__fSl9Z`,
	"questionInfo": `FeedbackModal_questionInfo__UHkwr`,
	"questionText": `FeedbackModal_questionText__w0p5c`,
	"feedbackSection": `FeedbackModal_feedbackSection__4GBji`,
	"feedbackTextarea": `FeedbackModal_feedbackTextarea__qVzlO`,
	"processInfo": `FeedbackModal_processInfo__P07nJ`,
	"processTag": `FeedbackModal_processTag__SkAfU`,
	"questionTag": `FeedbackModal_questionTag__eoR5z`,
	"modalFooter": `FeedbackModal_modalFooter__2l2KQ`,
	"cancelButton": `FeedbackModal_cancelButton__ggoIh`,
	"submitButton": `FeedbackModal_submitButton__JN8ad`
};
export default ___CSS_LOADER_EXPORT___;
